import fp from 'lodash/fp';
import React from 'react';
import { Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import { connect } from 'react-redux';
import { LinkContainer } from "react-router-bootstrap";
import { branch, lifecycle, mapProps, renderComponent, withProps } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { routes } from '../../../../constants';
import { businessActions, businessSelector } from '../../../../state/modules/business';
import Loading from '../../loading';
import ProgressReport from '../../shared/progress-report';

const getReportBreadCrumb = (userId) => (
  <Breadcrumb>
    <LinkContainer to={routes.app.teams.userProfiles(userId)}>
      <BreadcrumbItem>
        Professional Profile
      </BreadcrumbItem>
    </LinkContainer>
    <BreadcrumbItem active>
      Progress Report
    </BreadcrumbItem>
  </Breadcrumb>
)

const mapStateToProps = (state) => ({
  profile: state.business.user.profile,
  report: state.business.user.snapshotReport,
  business: businessSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
  getProfile: bindActionCreators(businessActions.business.user.getProfile, dispatch),
  getUserReport: bindActionCreators(businessActions.business.user.getSnapshotReport, dispatch)
})

export default compose(
  withProps(({
    match: {
      params: {
        userId,
        snapshotId
      }
    }
  }) => ({
    userId: parseInt(userId, 10),
    snapshotId: parseInt(snapshotId, 10)
  })),
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ business }) => !business,
    renderComponent(Loading)
  ),
  lifecycle({
    componentDidMount() {
      const {
        getUserReport,
        getProfile,
        userId,
        snapshotId,
        business,
      } = this.props;

      getProfile(business.id, userId);
      getUserReport(business.id, userId, snapshotId);
    }
  }),
  branch(
    ({ report, profile }) => !report || !profile,
    renderComponent(Loading)
  ),
  mapProps(
    ({ report, profile, userId }) => ({
      afsLicence: report.afsLicence,
      cpdActivity: report.cpdActivity,
      cpdDaysRemaining: report.cpdDaysRemaining,
      user: profile.user,
      cpdCategoryProgress: report.cpdCategoryProgress,
      defaultProgressLabel: fp.get('userIndustry.defaultProgressLabel')(report),
      filter: {
        fromDate: report.fromDate,
        toDate: report.toDate
      },
      reportBreadCrumb: getReportBreadCrumb(userId),
      goals: report.goals
    })
  )
)(ProgressReport);


// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/member-snapshot-report.js